import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api";

export const fetchUserPortfolio = createAsyncThunk(
    "portfolio/fetchUserPortfolio",
    async (userId: string, { rejectWithValue }) => {
        try {
            const response = await api.get(`/user-management/user-portfolio/${userId}`);
            return response.data.data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: "An unexpected error occurred" });
        }
    }
);

export const fetchUserCatchMetrics = createAsyncThunk(
    "portfolio/fetchUserCatchMetrics",
    async (userId: string, { rejectWithValue }) => {
        try {
            const response = await api.get(`/api/user-catch/catch-matrics/${userId}`);
            return response.data.data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: "An unexpected error occurred" });
        }
    }
);

export const fetchUserLoginHistory = createAsyncThunk(
    "portfolio/fetchUserLoginHistory",
    async ({ userId, page, limit }: { userId: string; page: number; limit: number }, { rejectWithValue }) => {
        try {
            const response = await api.get(`/api/users/login-history/${userId}?limit=${limit}&page=${page}`);
            return response.data.data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: "An unexpected error occurred" });
        }
    }
);

export const fetchUserBlockedList = createAsyncThunk(
    "portfolio/fetchUserBlockedList",
    async ({ userId, page, limit }: { userId: string; page: number; limit: number }, { rejectWithValue }) => {
        try {
            const response = await api.get(`/api/social-action/block-users/${userId}?limit=${limit}&page=${page}`);
            return response.data.data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: "An unexpected error occurred" });
        }
    }
);

export const fetchUserRecentCatches = createAsyncThunk(
    "portfolio/fetchUserRecentCatches",
    async ({ userId, page, limit }: { userId: string; page: number; limit: number }, { rejectWithValue }) => {
        try {
            const response = await api.get(`/api/user-catch/get-recent-catches/${userId}?limit=${limit}&page=${page}`);
            return response.data.data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: "An unexpected error occurred" });
        }
    }
);

export const promoteToSponsor = createAsyncThunk(
    "portfolio/promoteToSponsor",
    async (userId: string, { rejectWithValue }) => {
        try {
            const response = await api.patch(`/api/subscription-payment/promote/${userId}`);
            return response.data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: "An unexpected error occurred" });
        }
    }
);

export const fetchUserReferrals = createAsyncThunk(
    "portfolio/fetchUserReferrals",
    async ({ userId, page, limit }: { userId: string; page: number; limit: number }, { rejectWithValue }) => {
        try {
            const response = await api.get(`/api/referral/list/${userId}?limit=${limit}&page=${page}`);
            return response.data.data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: "An unexpected error occurred" });
        }
    }
);

export const portfolioSearch = createAsyncThunk(
    "portfolio/portfolioSearch",
    async (search: string, { rejectWithValue }) => {
        try {
            const response = await api.get(`/user-management/portfolio-search?search=${search}`);
            return response.data.data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: "An unexpected error occurred" });
        }
    }
);
